<template>
	<div class="modalInfo">
		<div
			:class="{
				'modal-container': true,
				'modal-info': true,
				'force-fit-content': fitContent,
			}"
			:style="{ zIndex: '9999999999' }"
		>
			<div class="modal-header">Copy Quote</div>
			<div class="modal-body">
				<div class="modal-body-info">
					<p>Would you like to copy this quote?</p>
				</div>
				<div
					v-if="userStores.length > 1"
					style="max-width: 250px; align-self: center; margin-bottom: 10px"
				>
					<InputRichDropdown
						:saturn="selectedStoreCode"
						:list="userStores"
						label="Store to copy to"
						placeholder="-- Select Something --"
						:valueMap="storeValuePredicate"
						:display="storeNamePredicate"
						:search="true"
						:selectAll="true"
						:single="false"
						:invalid="disableCloseButton"
						@change="handleChange"
					>
						<template #validation>
							<span v-if="!selectedStoreCode">Select a store to copy the deal to.</span>
						</template>
					</InputRichDropdown>
				</div>
			</div>

			<div class="modal-footer">
				<button
					class="button-unwind"
					@click="cancel"
				>
					No
				</button>
				<button
					class="cancelTextClass"
					@click="close"
					:disabled="disableCloseButton"
				>
					Yes
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import $modal from '@core/services/modal';
	import InputRichDropdown from '@core/components/InputRichDropdown.vue';
	import settings from 'settings';

	export default {
		name: 'modalCopyDeal',
		props: ['modal'],
		data() {
			return {
				fitContent: false,
				selectedStoreCode: null,
			};
		},
		computed: {
			userStores() {
				return settings.userStores;
			},
			displayStoreSelection() {
				// If we have more than one store. We must specify which store to copy to.
				return this.userStores.length > 1;
			},
			disableCloseButton() {
				// If we're displaying the store selection modal.
				// And we don't have a selected store.
				return this.displayStoreSelection && !this.selectedStoreCode;
			},
		},
		created() {},
		mounted() {},
		methods: {
			close() {
				$modal.close(this.selectedStoreCode);
			},
			cancel() {
				if (typeof this.modal.passedData.cancelFunction == 'function') {
					this.modal.passedData.cancelFunction();
				}
				$modal.cancel();
			},
			storeValuePredicate(store) {
				return store?.storeCode ?? '';
			},
			storeNamePredicate(store) {
				return store.storeName;
			},
			handleChange(storeCodeSelected) {
				this.selectedStoreCode = storeCodeSelected;
			},
		},
		components: {
			InputRichDropdown,
		},
	};
</script>
<style>
	.force-fit-content {
		min-width: 250px;
		width: fit-content !important;
	}
	.modalInfo {
		margin: auto;
	}

	.modalInfo .modal-body {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.modalInfo .modal-body-info {
		white-space: pre-wrap;
		margin: 10px 0;
	}

	.modalInfo .modal-body-info p {
		white-space: pre-line;
		word-wrap: break-word;
		overflow-wrap: break-word; /* For modern browsers to break long words */
		max-width: 100%; /* Ensure the text doesn't exceed the container's width */
	}

	.modalInfo .modal-body-info-important {
		font-weight: bold;
	}

	.modalInfo .modal-container.modal-info {
		width: auto;
		max-width: 815px;
	}

	.modal-footer-test {
	}
</style>
